import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { CircularProgress } from '@material-ui/core';
import { SearchStatus } from '../../../../constants';
import CustomInventoryItinerary from '../CustomInventoryItinerary';

const CustomInventoryList = ({
  tripId,
  onMouseEnter,
  onMouseLeave,
  isExpanded,
  doHaveBorderAround,
}) => {
  const { response = {}, searchStatus = {} } = useSelector(
    (store) => store.customInventory.customInventorySearches?.[tripId] || {},
  );
  const inventoryList =
    response &&
    response.travelOptions &&
    response.travelOptions.map((traveloption) => (
      <CustomInventoryItinerary
        key={traveloption?.itinerary?.uniqueKey}
        tripId={tripId}
        itinerary={traveloption.itinerary}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        isExpanded={isExpanded}
        doHaveBorderAround={doHaveBorderAround}
      />
    ));
  const progressBar = (
    <div className="text-center">
      <CircularProgress color="secondary" />
    </div>
  );
  return (
    <>
      {searchStatus === SearchStatus.DONE && inventoryList}
      {searchStatus === SearchStatus.SEARCHING && progressBar}
    </>
  );
};
CustomInventoryList.propTypes = {
  tripId: PropTypes.string.isRequired,
};

CustomInventoryList.propTypes = {
  tripId: PropTypes.string.isRequired,
  doHaveBorderAround: PropTypes.bool,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  isExpanded: PropTypes.shape({
    value: PropTypes.bool,
  }),
};

CustomInventoryList.defaultProps = {
  doHaveBorderAround: true,
  onMouseEnter: undefined,
  onMouseLeave: undefined,
  isExpanded: undefined,
};

export default CustomInventoryList;
